import {GetterTree} from 'vuex'
import {StatisticState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    mnStatisticDetail: state => state.mnStatisticDetail,
    mnStatisticGroup: state => state.mnStatisticGroup,
    mnGroupBy: state => state.mnGroupings.mnGroup,
    mnGroupByOptionally: state => state.mnGroupings.mnGroupOptionally,
};
